import Api from '@/services/Api'

export default {
  index (name, start, pageSize) {
    var results = Api().get('unit?name=' + name + "&start=" + start + "&limit=" + pageSize) ;
    console.log("In unit service back from server results=" + results) ;
    return results ;
  },
  id (unitId) {
    console.log("in unit id = " + unitId) ;
    var results = Api().get("unit/" + unitId) ;
    console.log("Back from API GET UNIT ID") ;
    return results ; 
  },
  create (newUnit) {
    console.log("in create unit") ;
    var results = Api().post('unitCreate', newUnit) ;
    console.log("after create, results=" + results) ;
    return results ;
  },
  edit (edittedUnit) {
    var results = Api().post('unitUpdate', edittedUnit) ;
    console.log("after edit, results=" + results) ;
    return results ;
  },
  mergeTo (edittedUnit) {
    console.log("in mergeTo serviced edittedunit=" + JSON.stringify(edittedUnit)) ;
    
    var results = Api().post('unitMergeTo', edittedUnit) ;
    console.log("after mergeTo, results=" + results) ;
    return results ;
  }
}



// WEBPACK FOOTER //
// ./src/services/UnitService.js